import { RolloverServiceClient } from "./rollover-client";
import { TaxPortalServiceClient } from "./taxportal-client";
import { UpgradeSiteServiceClient } from "./upgrade-site-client";
import { UserAssignmentServiceClient } from "./userassignment-client";
import { CustomPermissionServiceClient } from "./custompermission-client";
import { BulkSiteCretionServiceClient } from "./create-sites-client";
import { FileManagementServiceClient } from "./filemanagement-client";

import {
  REACT_APP_BASE_API_URL,
  REACT_APP_BULK_SITE_CREATION_API_URL,
  REACT_APP_UPGRADE_SITE_API_URL,
  REACT_APP_USER_ASSIGNMENT_API_URL,
  IsUpgradeSiteMicroserviceEnabled,
  REACT_APP_CUSTOM_PERMISSION_API_URL,
  REACT_APP_FILE_MANAGEMENT_API_URL,
  REACT_APP_CORPORATE_SIGHT_API_URL,
  REACT_APP_ROLLOVER_API_URL,
} from "../envVariables";
import { CorporateSightServiceClient } from "./corporatesight-client";

let upgradeSiteApiUrl = REACT_APP_UPGRADE_SITE_API_URL;
if (IsUpgradeSiteMicroserviceEnabled === "false") {
  upgradeSiteApiUrl = REACT_APP_BASE_API_URL;
}
export const taxPortalClientApi = new TaxPortalServiceClient(REACT_APP_BASE_API_URL);
export const createSitesClientApi = new BulkSiteCretionServiceClient(REACT_APP_BULK_SITE_CREATION_API_URL);
export const upgradeSiteClientApi = new UpgradeSiteServiceClient(upgradeSiteApiUrl);
export const rollOverClientApi = new RolloverServiceClient(REACT_APP_ROLLOVER_API_URL);
export const userAssignmentClientApi = new UserAssignmentServiceClient(REACT_APP_USER_ASSIGNMENT_API_URL);
export const customPermissionClientApi = new CustomPermissionServiceClient(REACT_APP_CUSTOM_PERMISSION_API_URL);
export const fileManagementClientApi = new FileManagementServiceClient(REACT_APP_FILE_MANAGEMENT_API_URL);
export const corporateSightClientApi = new CorporateSightServiceClient(REACT_APP_CORPORATE_SIGHT_API_URL);
